import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { SingleSelect } from "react-select-material-ui";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  RadioButtonGroup,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Layer,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Spinner,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Console,
  Video,
  Close,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import { callApiGetJson, callApiPostJson } from "./GlobalSettings";
import auth from "./Security/Auth";

class Canceldemo extends Component {
  /*  const { push } = React.useContext(RouterContext)
  const [layer, setLayer] = React.useState() */

  constructor(props) {
    super(props);

    this.state = {
      changeReason: "",
      bShowCancelSpinner: false,
      DemoToCancel: this.props.DemoToCancel,
    };

    this._HandleCancelClick = this._HandleCancelClick.bind(this);
    this.handleCancelStatusReason = this.handleCancelStatusReason.bind(this);
  }

  componentDidMount() {}

  handleCancelStatusReason(value) {
    this.setState({ changeReason: value });
  }

  _HandleCancelClick() {
    console.log(
      "*** Handle Cancel Clicked for Event ",
      this.state.DemoToCancel
    );
    var status = { EventStatus_ID: 4, EventStatus_Name: "Cancelled" };
    if (this.state.DemoToCancel) {
      this.setState({ bShowCancelSpinner: true });
      // var endpoint = "/Events/ChangeEventStatus";
      var endpoint = "/Events/ChangeEventStatusMod";
      let token = auth.getToken();
      var updateRequest = {
        EventID: this.state.DemoToCancel.Event_ID,
        ChangedEventStatus: status,
        UpdateStatusMessage: [this.state.changeReason],
        TMELabUsername: null,
        TMELabUerpwd: null,
        TMELabUserRealm: null,
        TMELabBaseURL: null,
      };
      callApiPostJson(endpoint, updateRequest, token).then((data) => {
        console.log(
          "Update event status to Cancelled and  result from API is :",
          data
        );
        if (data) {
          this.setState({ bShowCancelSpinner: false });
          console.log("Data returned from Cancel Status API is :", data);
          this.props.hide();
          //this.props.HandleCallBack(this.state.DemoToCancel.Event_ID);
        }
      });
    }
  }

  render() {
    var demoName = this.props.DemoToCancel.Event_Title;
    return (
      <Main flex="grow" fill="vertical" overflow="auto">
        <Layer animate modal>
          <Box align="center" justify="center">
            <Box
              align="center"
              justify="center"
              background={{ color: "brand" }}
              fill="horizontal"
            >
              <Box
                align="center"
                justify="between"
                direction="row"
                gap="medium"
                fill="horizontal"
              >
                <Heading size="small" level="1" margin="small">
                  CANCEL :
                </Heading>
                <Button icon={<Close />} secondary onClick={this.props.hide} />
              </Box>
              <Text size="large">{demoName}</Text>
            </Box>
            <Box
              align="stretch"
              justify="start"
              direction="column"
              pad="medium"
              gap="medium"
              fill="horizontal"
            >
              <Grid>
                <Text>Please provide the cancellation reason :</Text>
                <TextInput
                  plain={false}
                  type="text"
                  size="medium"
                  value={this.state.changeReason}
                  onChange={(event) =>
                    this.handleCancelStatusReason(event.target.value)
                  }
                />
              </Grid>
            </Box>
            <Box
              align="center"
              justify="center"
              direction="row"
              gap="large"
              margin="medium"
            >
              <Button
                label={
                  this.state.bShowCancelSpinner ? (
                    <Box
                      direction="row"
                      gap="small"
                      justify="center"
                      align="center"
                    >
                      <Spinner size="small" color="white" />{" "}
                      <Text>Cancelling Event..</Text>
                    </Box>
                  ) : (
                    "Cancel this Event"
                  )
                }
                active={false}
                primary
                onClick={this._HandleCancelClick}
                disabled={this.state.bShowCancelSpinner}
              />
            </Box>
          </Box>
        </Layer>
      </Main>
    );
  }
}
export default withRouter(Canceldemo);
